module.exports = __webpack_public_path__ + "img/3.eccec70f.png";